import { render, staticRenderFns } from "./IndicationDetailsModal.vue?vue&type=template&id=6506b0f7&"
import script from "./IndicationDetailsModal.vue?vue&type=script&lang=js&"
export * from "./IndicationDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports